import { stakingAddress } from 'app/features/web3/web3.config'
import { _1e18, number } from 'app/utils/web3'
import BN from 'bn.js'
import Web3 from 'web3'
import { Contract } from 'web3-eth-contract'

export const APR = async (
  web3: Web3,
  totalTokensBN: number,
  reward: Contract,
  tokenPriceBN: BN,
  staking: Contract
) => {
  const busdBalanceBN: BN = await reward.methods
    .balanceOf(stakingAddress)
    .call()

  const busdBalance = Number(busdBalanceBN.toString()) / 10 ** 18

  const totalTokens = totalTokensBN / 10 ** 18

  const tokenPrice = Number(tokenPriceBN) / 10 ** 18

  const usdValue = totalTokens * tokenPrice

  const blockNumber = await web3.eth.getBlockNumber()

  const currentBlock = await web3.eth.getBlock(blockNumber)

  const timeStamp = Number(currentBlock.timestamp)

  const lastUpdateTime: number = await staking?.methods.lastUpdateTime().call()

  const rewardRate: number = await staking?.methods.rewardRate().call()

  const currentTotalEarningsPerS =
    ((timeStamp - lastUpdateTime) * (rewardRate / 10 ** 18)) / totalTokens

  const earnedSinceLastUpdate = currentTotalEarningsPerS * totalTokens

  const earnedPerSecond = earnedSinceLastUpdate / (timeStamp - lastUpdateTime)

  let apr = ((earnedPerSecond * 31540000) / usdValue) * 100

  console.log('timestamp', timeStamp)
  console.log('lastUpdateTime', lastUpdateTime)
  console.log('rewardRate', rewardRate)
  console.log('totalTokens', totalTokens)
  console.log('earnedSinceLastUpdate', earnedSinceLastUpdate)
  console.log()

  console.log('currentTotalEarningsPerS', currentTotalEarningsPerS)

  console.log('earnedPerSecond', earnedPerSecond)
  console.log('apr', apr)

  console.log(`
  usdValue: ${usdValue}
  totalTokens: ${totalTokens}
  `)

  if (apr > 100) {
    apr = 100
  }

  return { busdBalance, apr }
}

export const userStakedTokens = async (
  web3: Web3,
  staking: Contract,
  selectedAccount: string
) => {
  const balance = await staking.methods.balanceOf(selectedAccount).call({
    from: selectedAccount,
  })
  return Number(
    number(web3, balance)
      .div(number(web3, _1e18(web3).toString()))
      .toString()
  )
}

export const getStakedValueFromTokens = async (
  web3: Web3,
  amount: number,
  tokenPrice: BN
) => {
  return Number(
    number(web3, amount).mul(tokenPrice).div(_1e18(web3)).toString()
  )
}

export const userStakedValue = async (
  web3: Web3,
  staking: Contract,
  selectedAccount: string,
  tokenPrice: BN
) => {
  const balance = await staking.methods.balanceOf(selectedAccount).call({
    from: selectedAccount,
  })
  const value = await getStakedValueFromTokens(web3, balance, tokenPrice)

  return value / 10 ** 18
}

export const getEarningEstimates = (userStakedValue: number, apr: number) => {
  return {
    year: userStakedValue * (apr / 100),
    month: userStakedValue * (apr / 100 / 12),
    day: userStakedValue * (apr / 100 / 365),
  }
}

export const canStake = async (
  amount: BN,
  selectedAccount: string,
  staking: Contract
) => {
  const result = await staking.methods.canStake(amount).call({
    from: selectedAccount,
  })

  return result
}

export const canWidthdraw = async (
  amount: BN,
  selectedAccount: string,
  staking: Contract
) => {
  const result = await staking.methods.canWidthdraw(amount).call({
    from: selectedAccount,
  })
  return result
}

export const getCanGetReward = async (
  staking: Contract,
  selectedAccount: string
) => {
  const result = await staking.methods
    .canGetReward()
    .call({ from: selectedAccount })
  return result
}

export const getTimeLeft = async (
  staking: Contract,
  selectedAccount: string
) => {
  const timeLeft: BN = await staking.methods
    .timeLeft()
    .call({ from: selectedAccount })
  return timeLeft
}

export const getEarned = async (staking: Contract, selectedAccount: string) => {
  const earned = await staking.methods.earned(selectedAccount).call({
    from: selectedAccount,
  })

  return Number(earned) / 10 ** 18
  // $('#earned').text(earned.toFixed(18) + ' BUSD')
}

export const getClaimRewards = async (
  staking: Contract,
  selectedAccount: string
) => {
  await staking.methods.getReward().send({
    from: selectedAccount,
  })
}
